export const ApplicationConstant = {
    ApplicationID : 32,
    clientId : 18,
    organizationId: 87,
    DEFAULT_DATE_FORMAT: 'YYYY-MM-DD',
    KWAppID: 31
}